<template>
    <v-dialog v-model="$store.state.readings.multiple" persistent max-width="1366px" transition="dialog-transition">
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">Create Orders</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.state.readings.multiple = false;"><v-icon>mdi-close-circle</v-icon></v-btn>
            </v-toolbar>
            <v-tabs
                v-model="tab"
                background-color="transparent"
                color="primary"
                grow
            >
                <v-tab
                    v-for="item in items"
                    :key="item"
                >
                    {{ item.tabName }}
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item
                    v-for="itm in items"
                    :key="itm"
                >
                    <v-container grid-list-xs fluid>
                        <v-data-iterator :items="itm.newTabContent" :items-per-page="1" :page="page">
                            <!--<template v-slot:header>
                                <v-toolbar dense color="primary" class="my-1 py-4">
                                    <template v-if="$vuetify.breakpoint.mdAndUp">
                                        <v-combobox dark dense label="SiteNum Look Up" :items="itm.tabContent" :item-text="'SiteNum'"
                                            v-model="cbx" @change="changeSiteNum(index)" clearable append-icon="mdi-magnify">
                                        </v-combobox>
                                        <v-spacer></v-spacer>
                                        <v-spacer></v-spacer>
                                    </template>
                                </v-toolbar>
                            </template>-->
                            <template v-slot:default="props">
                                <v-container grid-list-xs fluid v-for="(item, i) in props.items" :key="i">
                                    <v-simple-table dense>
                                        <thead>
                                            <tr>
                                                <th>Site #</th>
                                                <th>Tank #</th>
                                                <th>Product</th>
                                                <th>Volumen</th>
                                                <th>SafeFill</th>
                                                <th>Ullage</th>
                                                <th>Reading Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(tank, idxK) in item.Tanks" :key="'Tank-' + tank.SiteNum + '-' + idxK">
                                                <td>{{ tank.SiteNum }}</td>
                                                <td>{{ tank.TankNum }}</td>
                                                <td>{{ tank.DateTime }}</td>
                                                <td style="background: #F9f2aa;font-style: bold;">{{ tank.Volume }}</td>
                                                <td>{{ tank.Safefill }}</td>
                                                <td>{{ tank.Ullage }}</td>
                                                <td>{{ tank.Product }}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                    <v-simple-table dense>
                                        <tr>
                                            <td colspan="2"><v-combobox v-model="item.Station" hide-details :items="stations"
                                                    label="Station" class="mt-6 mb-2 mx-1" :item-value="'id'" :item-text="'Name'"
                                                    dense></v-combobox></td>
                                            <td colspan="2"><v-combobox v-model="item.Terminal" hide-details :items="terminals"
                                                    class="mt-6 mb-2 mx-1" label="Terminal" :item-value="'id'" :item-text="'Name'"
                                                    dense></v-combobox></td>
                                            <td colspan="2"><v-combobox v-model="item.Customer" hide-details :items="customers"
                                                    class="mt-6 mb-2 mx-1" label="Customer" :item-value="'id'" :item-text="'Name'"
                                                    dense></v-combobox></td>
                                            <td colspan="2"><v-combobox v-model="item.Supplier" hide-details :items="suppliers"
                                                    class="mt-6 mb-2 mx-1" label="Supplier" :item-value="'id'"
                                                    :item-text="'Supplier'" dense></v-combobox></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2"><v-text-field v-model="item.LoadingNumber" label="LoadingNumber"
                                                    class="mx-1" hide-details dense></v-text-field></td>
                                            <td><v-text-field label="Requested Date" id="DateRequested" :value="item.DateRequested"
                                                    v-mask="'####/##/## ##:##'" :rules="dateRules" type="tel" hide-details
                                                    dense></v-text-field></td>
                                            <td>
                                                <v-combobox v-model="item.OrderType" :items="order_types" :item-text="'OrderType'"
                                                    :item-value="'OrderTypeID'" label="Order Type" class="mx-3" hide-details dense
                                                    auto-select-first></v-combobox>
                                            </td>
                                            <td>
                                                <v-combobox v-model="item.SplitType" :items="split_types"
                                                    :item-text="'SplitTypeName'" :item-value="'SplitTypeID'" label="Split Type"
                                                    class="mx-3" auto-select-first></v-combobox>
                                            </td>
                                            <td>
                                                <v-combobox v-model="item.NoLoadType" :items="no_load_types"
                                                    :item-text="'NoLoadTypeName'" :item-value="'NoLoadTypeID'" label="No Load Type"
                                                    class="mx-3" auto-select-first></v-combobox>
                                            </td>
                                            <td>
                                                <v-checkbox
                                                class="mx-3"
                                                large
                                                label="Validate"
                                                v-model="item.Validate"
                                            ></v-checkbox>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="4"><v-textarea v-model="item.DispatchComments" label="Dispatch Comments"
                                                    class="mx-3" rows="4" no-resize></v-textarea></td>
                                            <td colspan="4"><v-textarea class="mx-3" rows="4" label="Special Instructions"
                                                    v-model="item.SpecialInstructions" no-resize></v-textarea></td>

                                        </tr>
                                        <tr class="mt-2">
                                            <th class="text-left">Product</th>
                                            <th class="text-left">Volumen</th>
                                            <th class="text-left">Ullage</th>
                                            <th class="text-left">Daily Average</th>
                                            <th class="text-left">RO Hrs</th>
                                            <th class="text-left">New RO Hrs</th>
                                            <th class="text-left">Product Code</th>
                                            <th class="text-left">Quantity</th>
                                            <th class="text-left">RT Hrs</th>
                                        </tr>
                                        <tr dense v-for="(it, ii) in item.OrderDetails" :key="'Detail' + ii">
                                            <td class="text-left">{{ it.Product }}</td>
                                            <td class="text-left">{{ it.Volume }}</td>
                                            <td class="text-left" style="background: #F9f2aa;font-style: bold;">{{ it.Ullage }}</td>
                                            <td class="text-left">{{ it.AvgDaily }}</td>
                                            <td class="text-left">{{ it.ROHrs }}</td>
                                            <td class="text-left">{{ it.NewROHrs }}</td>
                                            <td class="text-left">{{ it.ProductCode }}</td>
                                            <td><v-text-field @input="calculateHrs(it)" v-model="it.Quantity" hide-details
                                                    dense></v-text-field></td>
                                            <td class="text-left">{{ it.RTHrs }}</td>
                                        </tr>
                                    </v-simple-table>
                                </v-container>
                            </template>
                        </v-data-iterator>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['preOrders'],
    data: function () {
        return {
            stations: [],
            customers: [],
            terminals: [],
            suppliers: [],
            order_types: [],
            split_types: [],
            no_load_types: [],
            cbx: [],
            page: null,
            tab: null,
            items: [
                {
                    tabName: "Full Load",
                    tabContent: [],
                    newTabContent: [],
                },
                {
                    tabName: "Split",
                    tabContent: [],
                    newTabContent: [],
                },
            ],
        }
    },
    computed: {
        filteredItems() {
            return this.preOrders.filter(i => {
                return !this.cbx || i.SiteNum == this.cbx.SiteNum;
            });
        },
        RTHrs() {
            return this.products.map((item, index) => {
                var SafefillQty =
                    parseInt(item.Quantity) -
                    parseInt(this.products[index].Ullage);
                if (SafefillQty < 0) {
                    return 0;
                }
                return Math.round(SafefillQty / (item.AvgDaily / 18));
            });
        },
        orderTot() {
            return this.products.reduce(getOrderTotal, 0);

            function getOrderTotal(total, item) {
                var q = parseInt(item.Quantity);
                if (isNaN(q)) {
                    return total + 0;
                } else {
                    return total + q;
                }
            }
        }
    },
    async mounted() {
        console.log(this.preOrders);
        this.cbx = this.preOrders[0];
        await this.loadStations();
        this.categorizeLoads();
        this.loadCustomers();
        this.loadTerminals();
        this.loadSuppliers();
        this.loadOrderTypes();
        this.loadSplitTypes();
        this.loadNoLoadTypes();
    },
    methods: {
        calculateHrs: function(prd) {
            this.caculateRTHrs(prd);
            this.caculateNewROHrs(prd);
        },
        calculateQtyByProduct: function (prd, maxLoad, gasQty) {
            // Check the ullage to set the temporal Quantity
            let tempQuantity = Math.floor(Number(prd.Ullage) / 2000) * 2000;
            prd.tempDispQty = tempQuantity;
            prd.Quantity = tempQuantity;
            let prdTempRTH = this.caculateRTHrs(prd);

            // Check RT Hrs to to increase the quantity if possible
            while (prdTempRTH < 12 && prd.ROHrs >= prdTempRTH+3) {
                tempQuantity += 2000;
                prd.tempDispQty = tempQuantity;
                prd.Quantity = tempQuantity;
                prdTempRTH = this.caculateRTHrs(prd);

                if (prdTempRTH < 12 && prd.ROHrs >= prdTempRTH+3) {
                    continue;
                } else {
                    tempQuantity -= 2000;
                    prd.tempDispQty = tempQuantity;
                    prd.Quantity = tempQuantity;
                    prdTempRTH = this.caculateRTHrs(prd);
                    break;
                }
            }

            // Max 47k for LSD in Quad and 50k in Big Train
            let searchLSD = prd.Product.search("LSD");
            if (searchLSD != -1) {
                // The product is some type of LSD
                if (maxLoad == 54000 && tempQuantity >= 47000) {
                    // Adjust the quantity
                    tempQuantity = Math.floor(47000 / 2000) * 2000;
                } else if (maxLoad == 58000 && tempQuantity >= 50000) {
                    // Adjust the quantity
                    tempQuantity = Math.floor(50000 / 2000) * 2000;
                }
            } else if (gasQty != 0) {
                // The product is different from LSD
                if (maxLoad == 54000) {
                    let maxQtyToLoad = 54000 - gasQty;

                    if (tempQuantity > maxQtyToLoad) {
                        tempQuantity = Math.floor(maxQtyToLoad / 2000) * 2000;
                    }
                } else if (maxLoad == 58000) {
                    let maxQtyToLoad = 58000 - gasQty;

                    if (tempQuantity > maxQtyToLoad) {
                        tempQuantity = Math.floor(maxQtyToLoad / 2000) * 2000;
                    }
                }
            }

            prd.tempDispQty = tempQuantity;
            prd.Quantity = tempQuantity;
            let prdRTHrs = this.caculateRTHrs(prd);
            let prdNewROHrs = this.caculateNewROHrs(prd);
            prd.RTHrs = prdRTHrs;
            prd.NewROHrs = prdNewROHrs;

            console.log(prd);
            return prd;
        },
        sortItemsByFactor: function(items, factor, sort) {
            // Bubble sorting to sort items by factor
            let l = items.length;
            let aux;
            for (let i = 1; i < l; i++) {
                for (let r = 0; r < (l - i); r++) {
                    if (sort == "asc") {
                        if (items[r][factor] > items[r+1][factor]) {
                            aux = items[r];
                            items[r] = items[r+1];
                            items[r+1] = aux;
                        }
                    } else if (sort == "desc") {
                        if (items[r][factor] < items[r+1][factor]) {
                            aux = items[r];
                            items[r] = items[r+1];
                            items[r+1] = aux;
                        }
                    }
                }
            }
            return items;
        },
        calculateGasQty: function (prds, maxLoad) {
            // Check if there is LSD product to Dispatch and calculate the gasQty
            let gasQty = 0;
            for (let prd of prds) {
                // Check the ullage to set the temporal Quantity
                let searchLSD = prd.Product.search("LSD");
                console.log(searchLSD);
                if (searchLSD != -1) {
                    // The product is some type of LSD
                    // Calculate gas quantity with factor 1.14
                    let prdAdjusted = this.calculateQtyByProduct(prd, maxLoad, gasQty);
                    gasQty = prdAdjusted.Quantity * 1.14;
                    break;
                }
            }
            return gasQty;
        },
        setQuantities: function (tabContent, type) {
            var str = this.$store;
            for (let ct of tabContent) {
                // Set the Max Load depends Quad or Big Train
                let maxLoad = 0;
                if (ct.Station.QuadCall == 1) {
                    // Is Quad
                    maxLoad = 54000;
                } else {
                    maxLoad = 58000;
                }
                console.log("maxLoad", maxLoad);

                // Calculate the priority of each product (high/low) depends the RO Time
                for (let prd of ct.OrderDetails) {
                    if (prd.ROHrs <= 24) {
                        // High priority
                        prd.Priority = 'high';
                    } else {
                        // Low priority
                        prd.Priority = 'low';
                    }
                }

                // Check if there is high priority products
                let highPrds = ct.OrderDetails.filter(pr => pr.Priority == 'high');
                if (highPrds.length != 0) {
                    highPrds = this.sortItemsByFactor(highPrds, "ROHrs", "asc");
                } else {
                    continue;
                }
                console.log(ct.SiteNum, "highPrds sorted by lowest RO: ", highPrds);

                // Check if there is LSD product to Dispatch and calculate the gasQty
                let gasQty = this.calculateGasQty(highPrds, maxLoad);

                // Calculate Quantity for each high priority product the first time
                for (let prd of highPrds) {
                    prd = this.calculateQtyByProduct(prd, maxLoad, gasQty);
                }
                console.log(highPrds);

                // ------------------- Secure the next load for low priority products -------------------
                let lowPrds = ct.OrderDetails.filter(pr => pr.Priority == 'low');
                if (lowPrds.length != 0) {
                    lowPrds = this.sortItemsByFactor(lowPrds, "ROHrs", "asc");
                }
                console.log("lowPrds sorted by lowest RO: ", lowPrds);
                
                // Check if the higher ROHrs from the dispatch products is greater than
                // the ROHrs from the off products to add it to the current load or not
                highPrds = this.sortItemsByFactor(highPrds, "NewROHrs", "asc");
                let prdHigherROHrs = highPrds[highPrds.length-1];
                for (let prd of lowPrds) {
                    if (prdHigherROHrs.NewROHrs > prd.ROHrs) {
                        // Mark as high priority
                        prd.Priority == 'new-high';
                        break;
                    }
                    // Else - Ignore in the current dispatch
                }

                // Merge both arrays (high and new high) if needed
                let newHighPrds = lowPrds.filter(prd => prd.Priority == 'new-high');
                let endHighPrds;
                if (newHighPrds.length != 0) {
                    newHighPrds = this.sortItemsByFactor(newHighPrds, "ROHrs", "asc");
                    endHighPrds = highPrds.concat(newHighPrds);
                    console.log(endHighPrds);
                } else {
                    endHighPrds = highPrds;
                }

                // Check again if there is LSD product to Dispatch and calculate the gasQty
                gasQty = this.calculateGasQty(endHighPrds, maxLoad);

                // Re - Calculate Quantity for each new-high and high priority product
                for (let prd of endHighPrds) {
                    prd = this.calculateQtyByProduct(prd, maxLoad, gasQty);
                }
                endHighPrds = this.sortItemsByFactor(endHighPrds, "Quantity", "desc");
                console.log(endHighPrds);
                
                // Check if it is possible to get full load and ensure that maxLoad has not been exceeded
                let sumQtys = 0;
                let newLowPrds = lowPrds.filter(prd => prd.Priority == 'low');
                newLowPrds = this.sortItemsByFactor(newLowPrds, "ROHrs", "asc");
                newLowPrds[0].NewROHrs = newLowPrds[0].ROHrs;
                if (endHighPrds.length == 1) {
                    console.log(ct.SiteNum, "endHighPrds has 1 product...");
                    if (endHighPrds[0].Quantity > maxLoad) {
                        console.log(endHighPrds[0].Quantity, maxLoad);
                        endHighPrds[0].tempDispQty = maxLoad;
                        endHighPrds[0].Quantity = maxLoad;
                        endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                        endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);

                        let futureUllage = (((Number(endHighPrds[0].AvgDaily) / 24) * endHighPrds[0].RTHrs) + Number(endHighPrds[0].Ullage));
                        console.log(futureUllage);
                        if (futureUllage <= endHighPrds[0].Quantity) {
                            while (futureUllage <= endHighPrds[0].Quantity) {
                                endHighPrds[0].tempDispQty -= 2000;
                                endHighPrds[0].Quantity -= 2000;
                                endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                                endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);
                                futureUllage = (((Number(endHighPrds[0].AvgDaily) / 24) * endHighPrds[0].RTHrs) + Number(endHighPrds[0].Ullage));
                            }
                        }

                        if (endHighPrds[0].NewROHrs >= newLowPrds[0].NewROHrs) {
                            let remainingQty = 0;
                            endHighPrds.push(newLowPrds[0]);
                            while (endHighPrds[0].NewROHrs >= endHighPrds[1].NewROHrs) {
                                endHighPrds[0].tempDispQty -= 2000;
                                endHighPrds[0].Quantity -= 2000;
                                endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                                endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);
                                remainingQty += 2000;

                                endHighPrds[1].tempDispQty = remainingQty;
                                endHighPrds[1].Quantity = remainingQty;
                                endHighPrds[1].RTHrs = this.caculateRTHrs(endHighPrds[1]);
                                endHighPrds[1].NewROHrs = this.caculateNewROHrs(endHighPrds[1]);
                            }
                        } else {
                            let diffQty = maxLoad - endHighPrds[0].Quantity;
                            console.log(Number(newLowPrds[0].Ullage), diffQty);

                            for (let prd of newLowPrds) {
                                if (Number(prd.Ullage) >= diffQty) {
                                    endHighPrds.push(prd);
                                    endHighPrds[1].tempDispQty = diffQty;
                                    endHighPrds[1].Quantity = diffQty;
                                    endHighPrds[1].RTHrs = this.caculateRTHrs(endHighPrds[1]);
                                    endHighPrds[1].NewROHrs = this.caculateNewROHrs(endHighPrds[1]);
                                    break;
                                }
                            }
                        }
                    } else {
                        console.log(endHighPrds[0].Quantity, " is less than ", maxLoad);
                        let futureUllage = (((Number(endHighPrds[0].AvgDaily) / 24) * endHighPrds[0].RTHrs) + Number(endHighPrds[0].Ullage));
                        console.log(futureUllage);
                        if (futureUllage <= endHighPrds[0].Quantity) {
                            while (futureUllage <= endHighPrds[0].Quantity) {
                                endHighPrds[0].tempDispQty -= 2000;
                                endHighPrds[0].Quantity -= 2000;
                                endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                                endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);
                                futureUllage = (((Number(endHighPrds[0].AvgDaily) / 24) * endHighPrds[0].RTHrs) + Number(endHighPrds[0].Ullage));
                            }
                        }

                        if (endHighPrds[0].NewROHrs >= newLowPrds[0].NewROHrs) {
                            let remainingQty = 0;
                            endHighPrds.push(newLowPrds[0]);
                            while (endHighPrds[0].NewROHrs >= endHighPrds[1].NewROHrs) {
                                endHighPrds[0].tempDispQty -= 2000;
                                endHighPrds[0].Quantity -= 2000;
                                endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                                endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);
                                remainingQty += 2000;

                                endHighPrds[1].tempDispQty = remainingQty;
                                endHighPrds[1].Quantity = remainingQty;
                                endHighPrds[1].RTHrs = this.caculateRTHrs(endHighPrds[1]);
                                endHighPrds[1].NewROHrs = this.caculateNewROHrs(endHighPrds[1]);
                            }
                        } else {
                            let diffQty = maxLoad - endHighPrds[0].Quantity;
                            console.log(Number(newLowPrds[0].Ullage), diffQty);

                            for (let prd of newLowPrds) {
                                if (Number(prd.Ullage) >= diffQty) {
                                    endHighPrds.push(prd);
                                    endHighPrds[1].tempDispQty = diffQty;
                                    endHighPrds[1].Quantity = diffQty;
                                    endHighPrds[1].RTHrs = this.caculateRTHrs(endHighPrds[1]);
                                    endHighPrds[1].NewROHrs = this.caculateNewROHrs(endHighPrds[1]);
                                    break;
                                }
                            }
                        }
                    }
                } else if (endHighPrds.length == 2) {
                    console.log(ct.SiteNum, "endHighPrds has 2 products...");
                    sumQtys = endHighPrds[0].Quantity + endHighPrds[1].Quantity;
                    if (sumQtys > maxLoad) {
                        if (Number(endHighPrds[0].Ullage) >= 48000) {
                            let diff = maxLoad - 48000;

                            endHighPrds[0].tempDispQty = 48000;
                            endHighPrds[0].Quantity = 48000;
                            endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                            endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);

                            endHighPrds[1].tempDispQty = diff;
                            endHighPrds[1].Quantity = diff;
                            endHighPrds[1].RTHrs = this.caculateRTHrs(endHighPrds[1]);
                            endHighPrds[1].NewROHrs = this.caculateNewROHrs(endHighPrds[1]);

                            let futureUllage = (((Number(endHighPrds[1].AvgDaily) / 24) * endHighPrds[1].RTHrs) + Number(endHighPrds[1].Ullage));
                            console.log(futureUllage);
                            let qtyToBeAllocated = 0;
                            if (futureUllage < endHighPrds[1].Quantity) {
                                while (futureUllage < endHighPrds[1].Quantity) {
                                    endHighPrds[1].tempDispQty -= 2000;
                                    endHighPrds[1].Quantity -= 2000;
                                    endHighPrds[1].RTHrs = this.caculateRTHrs(endHighPrds[1]);
                                    endHighPrds[1].NewROHrs = this.caculateNewROHrs(endHighPrds[1]);
                                    futureUllage = (((Number(endHighPrds[1].AvgDaily) / 24) * endHighPrds[1].RTHrs) + Number(endHighPrds[1].Ullage));
                                    qtyToBeAllocated += 2000;
                                }
                            }

                            endHighPrds[0].tempDispQty += qtyToBeAllocated;
                            endHighPrds[0].Quantity += qtyToBeAllocated;
                            endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                            endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);

                            let futureUllg = (((Number(endHighPrds[0].AvgDaily) / 24) * endHighPrds[0].RTHrs) + Number(endHighPrds[0].Ullage));
                            console.log(futureUllg);
                            if (futureUllg < endHighPrds[0].Quantity) {
                                while (futureUllage < endHighPrds[0].Quantity) {
                                    endHighPrds[0].tempDispQty -= 2000;
                                    endHighPrds[0].Quantity -= 2000;
                                    endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                                    endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);
                                    futureUllage = (((Number(endHighPrds[0].AvgDaily) / 24) * endHighPrds[0].RTHrs) + Number(endHighPrds[0].Ullage));
                                }
                            }
                        }
                    }
                } else if (endHighPrds.length == 3) {
                    console.log(ct.SiteNum, "endHighPrds has 3 products...");
                    sumQtys = endHighPrds[0].Quantity + endHighPrds[1].Quantity + endHighPrds[2].Quantity;
                    if (sumQtys > maxLoad) {
                        let diff = maxLoad - 40000;
                        let qty = diff / 2;

                        endHighPrds[0].tempDispQty = 40000;
                        endHighPrds[0].Quantity = 40000;
                        endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                        endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);

                        endHighPrds[1].tempDispQty = qty;
                        endHighPrds[1].Quantity = qty;
                        endHighPrds[1].RTHrs = this.caculateRTHrs(endHighPrds[1]);
                        endHighPrds[1].NewROHrs = this.caculateNewROHrs(endHighPrds[1]);

                        endHighPrds[2].tempDispQty = qty;
                        endHighPrds[2].Quantity = qty;
                        endHighPrds[2].RTHrs = this.caculateRTHrs(endHighPrds[2]);
                        endHighPrds[2].NewROHrs = this.caculateNewROHrs(endHighPrds[2]);
                    }
                } else if (endHighPrds.length == 4) {
                    console.log(ct.SiteNum, "endHighPrds has 4 products...");
                }

                console.log(endHighPrds);
                // Checks if the order is suitable for split
                sumQtys = 0;
                for (let prd of endHighPrds) {
                    sumQtys += prd.Quantity;
                }
                if (type == 'full-load') {
                    if (sumQtys <= 45000) {
                        // Is suitable for split
                        this.items[1].newTabContent.push(ct);
                    } else if (sumQtys <= maxLoad) {
                        // Not Is suitable for split - 2k limite menos de full load
                        this.items[0].newTabContent.push(ct);
                    }
                }
                
                console.log(this.items[1].newTabContent, this.items[0].newTabContent);

                if (this.items[1].newTabContent.length == 0 && this.items[0].newTabContent.length == 0) {
                    str.dispatch('setSnackbar', {
                        color: 'warning',
                        text: 'The sites you selected do not need to load product now.'
                    });
                }
            }
        },
        categorizeLoads: function () {
            console.log(this.preOrders);
            for (let ord of this.preOrders) {
                if (ord.Station.SplitSite == 1) {
                    this.items[1].tabContent.push(ord);
                    this.items[1].newTabContent.push(ord);
                } else {
                    this.items[0].tabContent.push(ord);
                }
            }

            console.log("Full Load", this.items[0].tabContent);
            console.log("Split", this.items[1].tabContent);

            // Logic for Full Load
            this.setQuantities(this.items[0].tabContent, "full-load");

            // Logic for Split
            this.setQuantities(this.items[1].tabContent, "split");

            console.log("New Full Load", this.items[0].newTabContent);
            console.log("New Split", this.items[1].newTabContent);

        },
        caculateNewROHrs: function (prd) {
            let newROHrs = (Math.round(Number(prd.Quantity) / Number(prd.AvgDaily))) * 24;
            prd.NewROHrs = newROHrs + prd.ROHrs;
            return prd.NewROHrs;
        },
        caculateRTHrs: function (item) {
            var SafefillQty = parseInt(item.Quantity) - parseInt(item.Ullage);
            if (SafefillQty < 0) {
                item.RTHrs = 0;
            } else {
                item.RTHrs = Math.round(SafefillQty / (item.AvgDaily / 18));
            }

            return item.RTHrs;
        },
        loadStations: async function () {
            this.$store.state.isLoading = true;
            await axios
                .get('station/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.stations = response.data.data;

                    for (let ord of this.preOrders) {
                        const idxSt = this.stations.findIndex(st => {
                            return ord.StationId == st.id;
                        });
                        ord.Station = this.stations[idxSt];
                    }

                    console.log(this.stations);
                    console.log(this.preOrders);
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        changeSiteNum: function () {
            const selectedIndex = this.preOrders.indexOf(this.cbx);
            console.log('Índice seleccionado:', selectedIndex);

            const idxSt = this.stations.findIndex(st => {
                return this.preOrders[selectedIndex].StationId == st.id;
            });
            this.preOrders[selectedIndex].Station = this.stations[idxSt];

            const idxSp = this.suppliers.findIndex(st => {
                return this.preOrders[selectedIndex].SupplierId == st.id;
            });

            this.preOrders[selectedIndex].Supplier = this.suppliers[idxSp];

            const idxCt = this.customers.findIndex(st => {
                return this.preOrders[selectedIndex].CustomerId == st.id;
            });

            this.preOrders[selectedIndex].Customer = this.customers[idxCt];

            const idxTm = this.terminals.findIndex(st => {
                return this.preOrders[selectedIndex].TerminalId == st.id;
            });

            this.preOrders[selectedIndex].Terminal = this.terminals[idxTm];
        },
        loadCustomers: function () {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.customers = response.data.data;
                    const idxSt = this.customers.findIndex(st => {
                        return this.preOrders[0].CustomerId == st.id;
                    });

                    this.preOrders[0].Customer = this.customers[idxSt];
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadTerminals: function () {
            this.$store.state.isLoading = true;
            axios
                .get('terminal/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.terminals = response.data.data;
                    const idxSt = this.terminals.findIndex(st => {
                        return this.preOrders[0].TerminalId == st.id;
                    });

                    this.preOrders[0].Terminal = this.terminals[idxSt];
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadSuppliers: function () {
            this.$store.state.isLoading = true;
            axios
                .get('supplier/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.suppliers = response.data.data;
                    const idxSt = this.suppliers.findIndex(st => {
                        return this.preOrders[0].SupplierId == st.id;
                    });

                    this.preOrders[0].Supplier = this.suppliers[idxSt];
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadOrderTypes: function () {
            axios
                .get('order-type', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.order_types = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadSplitTypes: function () {
            axios
                .get('split-type', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.split_types = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadNoLoadTypes: function () {
            axios
                .get('no-load-type', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.no_load_types = response.data;
                    console.log(this.no_load_types);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    }
}
</script>